import React from "react";
import {useStoreState} from "easy-peasy";
import CTA from '../routes/intro-cta';
import Quiz from '../routes/quiz';
import ResultsPage from '../routes/results-page';
/* import store from "../store"; */

export default () => {
    const path = useStoreState(state => state.path.current);

    switch (path) {
    case `/intro` :
        return (<CTA />);
    case `/q1` :
        return (<Quiz questionIndex={1} />);
    case `/q2` :
        return (<Quiz questionIndex={2} />);
    case `/q3` :
        return (<Quiz questionIndex={3} />);
    case `/q4` :
        return (<Quiz questionIndex={4} />);
    case `/results` :
        return <ResultsPage />;
    default :
        return <div>404</div>;
    }
};
